export const autoTestIdState = {
  counter: 0,
};
